import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["data-section-id"]
const _hoisted_2 = { class: "flex items-center justify-between p-4" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

import { computed } from 'vue';
import useChecklists from '@/checklists/useChecklists';
import Icon from '@/components/ui/Icon.vue';
import checklistStrings from './checklist-strings';

interface Props {
  sectionId: string;
  onClick: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChecklistsSection',
  props: {
    sectionId: null,
    onClick: { type: Function }
  },
  setup(__props: any) {

const props = __props as {
  sectionId: string;
  onClick: () => void;
};



const { isSectionCompleted, isSectionNotStarted, getSectionById } = useChecklists();

const section = computed(() => getSectionById(props.sectionId));

const isCompleted = computed(() => isSectionCompleted(props.sectionId));
const isNotStarted = computed(() => isSectionNotStarted(props.sectionId));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["relative overflow-hidden rounded transition-colors", { 'bg-default hover:bg-muted': !_unref(isCompleted) }]),
    "data-section-id": __props.sectionId,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.onClick && __props.onClick(...args)))
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass([
          'flex items-center gap-2 py-0.5 text-sm font-medium text-default',
          {
            'text-opacity-50': _unref(isCompleted),
          }
        ])
      }, [
        (_unref(isCompleted))
          ? (_openBlock(), _createBlock(Icon, {
              key: 0,
              type: "check-circle",
              class: "text-green-400 w-4 h-4"
            }))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_unref(checklistStrings).sections[__props.sectionId]), 1)
      ], 2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass([
            'p-1 text-xs font-medium text-subtle',
            {
              'text-opacity-50': _unref(isCompleted),
            }
          ])
        }, [
          (_unref(isNotStarted))
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(checklistStrings).section_not_started), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(section).completed) + " / " + _toDisplayString(_unref(section).steps.length) + " tasks ", 1))
        ], 2),
        _createVNode(Icon, {
          type: "chevron-right",
          class: "text-subtle w-6 h-6"
        })
      ])
    ])
  ], 10, _hoisted_1))
}
}

})